import React from 'react';
import styled from 'styled-components';
import { List, Button } from 'antd';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { PiMapPin } from 'react-icons/pi';
import type { FreePhoto_Base } from '~/common/typescript/models/FreePhoto';
import { LazyImage } from './LazyImage';
import { FreePhotoStampOverlay } from './FreePhotoStampOverlay';
import { getLocationText } from '../utils/freePhotoUtils';
import { useFreePhotoMetadata } from '../hooks/useFreePhotoMetadata';
import { useUserById } from '../hooks/useUserById';
import DateTimeViewer from '~/components/common/DateTimeViewer/DateTimeViewer';

interface FreePhotoListItemProps {
  photo: FreePhoto_Base;
  onView: () => void;
  onDownload: () => void;
}

export const FreePhotoListItem: React.FC<FreePhotoListItemProps> = ({ photo, onView, onDownload }) => {
  const metadata = useFreePhotoMetadata(photo);
  const { user } = useUserById(photo.user_id);

  const locationText = getLocationText(metadata);
  const userName = user ? (user.fullname || user.username) : null;

  return (
    <List.Item
      actions={[
        <Button key="view" type="text" icon={<EyeOutlined />} onClick={onView}>
          Xem
        </Button>,
        <Button key="download" type="text" icon={<DownloadOutlined />} onClick={onDownload}>
          Tải xuống
        </Button>,
      ]}
    >
      <List.Item.Meta
        avatar={
          <UI_AvatarWrapper>
            <LazyImage uuid={photo.uuid} ossProcess="image/resize,w_300" alt={photo.file_name} width={80} height={80} />
            <FreePhotoStampOverlay metadata={metadata} createdAt={photo.created_at} />
          </UI_AvatarWrapper>
        }
        title={null}
        description={
          <UI_Description>
            {/* Địa chỉ — primary, rõ */}
            <UI_Location><PiMapPin style={{ marginRight: '4px', verticalAlign: '-1px' }} />{locationText}</UI_Location>

            {/* Chụp lúc: ___ bởi ___ — secondary, nhạt */}
            <UI_Meta>
              chụp lúc:{' '}
              <DateTimeViewer
                date={photo.created_at}
                initialMode="relative"
                severity="secondary"
                showTooltip
              />
              {userName && (
                <> bởi <UI_UserName>{userName}</UI_UserName></>
              )}
            </UI_Meta>
          </UI_Description>
        }
      />
    </List.Item>
  );
};

const UI_AvatarWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 4px;
  flex-shrink: 0;
`;

const UI_Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const UI_Location = styled.div`
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UI_Meta = styled.div`
  font-size: 11px;
  color: #999;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
`;

const UI_UserName = styled.span`
  color: #888;
  font-weight: 500;
  margin-left: 2px;
`;